import { persist } from './api-client';

/**
 * Persist multiple properties at once for a document
 * 
 * @param {string} _id - The document _id to update
 * @param {Object} properties - Object containing the properties to update
 * @param {boolean} backup - Whether to create a backup of the changes
 * @returns {Promise<void>}
 */
export async function persistQwanta(_id, properties, backup = false) {
  try {
    // Validate inputs
    if (!_id) {
      throw new Error("Document _id is required");
    }
    if (!properties || typeof properties !== 'object' || Array.isArray(properties)) {
      throw new Error("Properties must be a non-array object");
    }

    // Use the API client persist function with all properties as delta
    await persist(properties, _id, null, null, backup);

    return true;
  } catch (error) {
    console.error("Error persisting Qwanta:", error);
    throw error; // Rethrow for higher-level handling
  }
}